// 대시보드 > 차트
export const CHART_DATA = {
    userPerMonth: 6429,
    userPerDay: 250,
    totalRegisterUser: 1264,
    subscribedUser: 80346,
    curMonthIncome: 6248000,
    curYearIncome: 124520000,
    userAmountPerMonth: [
        { month: 1, count: 30 },
        { month: 2, count: 10 },
        { month: 3, count: 2 },
        { month: 4, count: 22 },
        { month: 5, count: 50 },
        { month: 6, count: 75 },
        { month: 7, count: 12 },
        { month: 8, count: 25 },
        { month: 9, count: 36 },
        { month: 10, count: 33 },
        { month: 11, count: 48 },
        { month: 12, count: 8 }
    ],
    newUserPerMonth: [
        { month: 1, count: 30 },
        { month: 2, count: 10 },
        { month: 3, count: 20 },
        { month: 4, count: 22 },
        { month: 5, count: 50 },
        { month: 6, count: 75 },
        { month: 7, count: 12 },
        { month: 8, count: 2 },
        { month: 9, count: 3 },
        { month: 10, count: 33 },
        { month: 11, count: 42 },
        { month: 12, count: 78 }
    ]
};
// 대시보드 > 최근 등록 회원
export const LATEST_JOINED__DATA = [
    {
        id: 1,
        createdAt: '2025-03-03',
        loginType: 3,
        userName: '홍길동',
        cellphone: '01012341234',
        email: 'example@platcube.com',
        qrAmount: 0
    },
    {
        id: 2,
        createdAt: '2025-03-03',
        loginType: 2,
        userName: '홍길동',
        cellphone: '01012341234',
        email: 'example@platcube.com',
        qrAmount: 5
    },
    {
        id: 3,
        createdAt: '2025-03-03',
        loginType: 2,
        userName: '홍길동',
        cellphone: '01012341234',
        email: 'example@platcube.com',
        qrAmount: 5
    },
    {
        id: 4,
        createdAt: '2025-03-03',
        loginType: 1,
        userName: '홍길동',
        cellphone: '01012341234',
        email: 'example@platcube.com',
        qrAmount: 5
    },
    {
        id: 5,
        createdAt: '2025-03-03',
        loginType: 1,
        userName: '홍길동',
        cellphone: '01012341234',
        email: 'example@platcube.com',
        qrAmount: 5
    }
];
